import { Card, CardBody, CardHeader, Collapse, Input } from "reactstrap";
import { Href, TwoStepVerificationTitle } from "../../../../../../Constants/Constants";
import { useAppDispatch, useAppSelector } from "../../../../../../ReduxToolkit/Hooks";
import { setAccount } from "../../../../../../ReduxToolkit/Reducers/Messenger/MainSidebar";

const TwoStepVerification = () => {
  const { account } = useAppSelector((state) => state.mainSidebar);
  const dispatch = useAppDispatch();
  return (
    <Card>
      <CardHeader onClick={() => dispatch(setAccount(account !== "3" ? "3" : ""))}>
        <a href={Href}>
         {TwoStepVerificationTitle}
          <i className={`fa fa-angle-${account === "3" ? "up" : "down"}`} />
        </a>
      </CardHeader>
      <Collapse className={`${account === "3" ? "show" : ""}`}>
        <CardBody>
          <div className="d-flex">
            <div className="flex-grow-1">
              <h5>Enable</h5>
            </div>
            <div className="media-right form-switch">
              <Input type="checkbox" />
            </div>
          </div>
          <p><b>Note : </b>For added security, enable two-step verification, which will require a PIN when registering your phone number with chatzy again.</p>
        </CardBody>
      </Collapse>
    </Card>
  );
};

export default TwoStepVerification;
